import { render, staticRenderFns } from "./ShippedCard.vue?vue&type=template&id=5e62c1fd&scoped=true&"
import script from "./ShippedCard.vue?vue&type=script&lang=js&"
export * from "./ShippedCard.vue?vue&type=script&lang=js&"
import style0 from "./ShippedCard.vue?vue&type=style&index=0&id=5e62c1fd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e62c1fd",
  null
  
)

export default component.exports